import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { PlayArrow } from '@mui/icons-material';
import { PgPage } from '../common/PgPage';
import { PG_SETTINGS_GROUP } from '../constants';
import { CyclesList } from './CyclesList';
import { RunNowDialog } from './RunNowDialog';
import { RunsList } from './RunsList';
import { ScheduleForm } from './ScheduleForm';

type TScheduleView = 'runs' | 'cycles';

/** Settings → Schedule: monthly cycle settings, manual run, runs and invoices of a cycle (03 §4.6). */
export const Schedule: FC = () => {
	const navigate = useNavigate();
	const [runNowOpen, setRunNowOpen] = useState(false);
	const [view, setView] = useState<TScheduleView>('runs');

	const handleViewChange = (_event: unknown, next: TScheduleView | null) => {
		if (!next || next === view) return;
		// The two lists share the URL query (page, sort, filters): start the other one clean.
		navigate({ search: '' }, { replace: true });
		setView(next);
	};

	return (
		<PgPage
			title="Schedule"
			group={PG_SETTINGS_GROUP}
			actions={
				<Button
					size="small"
					variant="contained"
					startIcon={<PlayArrow />}
					onClick={() => setRunNowOpen(true)}
				>
					Run now
				</Button>
			}
		>
			<ScheduleForm />
			<Box sx={{ mb: 1 }}>
				<ToggleButtonGroup size="small" exclusive value={view} onChange={handleViewChange}>
					<ToggleButton value="runs">Runs</ToggleButton>
					<ToggleButton value="cycles">Invoices of a cycle</ToggleButton>
				</ToggleButtonGroup>
			</Box>
			{view === 'runs' ? <RunsList /> : <CyclesList />}
			<RunNowDialog open={runNowOpen} onClose={() => setRunNowOpen(false)} />
		</PgPage>
	);
};
